import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { MainHeader } from "@components/Header";
import { TabBar } from "@components/TabBar";
import { Analytics } from "@services";
import { getRouteForPath } from "@utils";
import { PageHeader } from "./PageHeader";
import { Container, useStyles } from "./styles";
import { MainLayoutProps } from "./types";

export const MainLayout = ({
  showTab,
  wrapperStyle,
  containerStyle,
  loader = false,
  analytics = true,
  pageHeader,
  rightHeader,
  children,
}: MainLayoutProps) => {
  const styles = useStyles();
  const location = useLocation();

  const route = getRouteForPath(location.pathname);

  useEffect(() => {
    if (!analytics) return;

    Analytics.page(route);
  }, [analytics]);

  if (loader) {
    return (
      <>
        <MainHeader showTab={showTab} />
        {children}
        <TabBar showTab={showTab} />
      </>
    );
  }

  return (
    <div style={styles.page}>
      <MainHeader showTab={showTab} />
      <div
        style={{
          ...styles.wrapper,
          ...wrapperStyle,
          // AppNav is a single 76px bar; 100 leaves consistent breathing room.
          marginTop: 100,
        }}
      >
        <Container
          style={{
            ...containerStyle,
            ...(!showTab && { marginBottom: 0 }),
          }}
        >
          <PageHeader title={pageHeader} rightHeader={rightHeader} />
          {children}
        </Container>
      </div>
      <TabBar showTab={showTab} />
    </div>
  );
};
